/**
 * Copyright (C) 2021 Thomas Weber
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU General Public License version 3 as
 * published by the Free Software Foundation.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program.  If not, see <https://www.gnu.org/licenses/>.
 */

import './import-first';

import React from 'react';
import {Toaster} from 'react-hot-toast';

import Interface from './render-interface.jsx';
import ScreenGate from './screen-gate.jsx';
import render from './app-target';


render(
    <React.Fragment>
        <ScreenGate>
            <Interface />
        </ScreenGate>
        <Toaster
            position="top-center"
            toastOptions={{
                style: {
                    fontFamily: 'inherit',
                    fontWeight: 600,
                    fontSize: '0.875rem',
                    border: '2px solid #111111',
                    borderRadius: '8px',
                    boxShadow: '4px 4px 0px 0px #111111'
                },
                success: {
                    style: {background: '#86efac'}
                },
                error: {
                    style: {background: '#fca5a5'},
                    duration: 5000
                }
            }}
        />
    </React.Fragment>
);
